<template>
    <!-- Client 2 - Bootstrap Brain Component -->
    <section class="py-3 py-md-5 py-xl-8">
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                    <h2 class="fs-6 text-secondary mb-2 text-uppercase text-center">Link Terkait</h2>
                    <h2 class="mb-4 display-5 text-center">Aplikasi Kepegawaian</h2>
                    <p class="fs-5 text-secondary mb-5 text-center">Layanan Kepegawaian Berbasis Digital Dapat Dilihat
                        Pada Galeri Ini.</p>
                    <hr class="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle">
                </div>
            </div>
        </div>

        <div class="container overflow-hidden">
            <div class="row gy-4">
                <div v-for="link in linkList" :key="link.id" class="col-6 col-md-4 col-xl-3 text-center">
                    <a :href="link.url" :target="link.target" class="text-secondary bg-light px-4 py-3 px-md-6 py-md-4 px-lg-8 py-lg-5 text-center 
           d-flex flex-column align-items-center" data-aos="zoom-out-left"
     data-aos-anchor-placement="top-center"> <!-- Ditambahkan d-flex, flex-column, align-items-center -->
                        <img src="../../assets/img/logo/logowarna.png" alt="Icon" class="img-monochrome" width="70%"
                            fill="currentColor" viewBox="0 0 284 110" />
                        <!-- Gambar SVG tetap di atas -->
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="70%" fill="currentColor" viewBox="0 0 284 110">
                            <path
                                d="m141.51,52.13c.49-1.29.74-3.39.74-6.31v-12.29c0-2.83-.25-4.9-.74-6.21-.49-1.31-1.36-1.96-2.61-1.96s-2.05.65-2.54,1.96c-.49,1.31-.74,3.38-.74,6.21v12.29c0,2.92.24,5.02.71,6.31.47,1.29,1.33,1.93,2.57,1.93s2.11-.64,2.61-1.93h0Zm-9.98,6.18c-1.78-1.2-3.05-3.07-3.8-5.6-.75-2.53-1.13-5.9-1.13-10.1v-5.73c0-4.25.43-7.66,1.29-10.23.86-2.57,2.2-4.45,4.02-5.63,1.82-1.18,4.22-1.77,7.18-1.77s5.26.6,7.02,1.8c1.76,1.2,3.05,3.08,3.86,5.63.81,2.55,1.22,5.95,1.22,10.2v5.73c0,4.2-.4,7.58-1.19,10.14-.79,2.55-2.08,4.42-3.86,5.6-1.78,1.18-4.19,1.77-7.24,1.77s-5.59-.6-7.37-1.8m137.82-32.22c-.45.56-.75,1.47-.9,2.74-.15,1.27-.22,3.19-.22,5.76v2.83h6.5v-2.83c0-2.53-.09-4.45-.26-5.76-.17-1.31-.48-2.23-.93-2.77-.45-.54-1.15-.81-2.09-.81s-1.64.28-2.09.84h0Zm-1.13,16.61v2c0,2.53.07,4.43.22,5.7.15,1.27.46,2.19.93,2.77.47.58,1.2.87,2.19.87,1.33,0,2.24-.52,2.74-1.55.49-1.03.76-2.75.8-5.15l7.66.45c.04.34.06.82.06,1.42,0,3.65-1,6.37-2.99,8.17-1.99,1.8-4.82,2.7-8.46,2.7-4.38,0-7.44-1.37-9.2-4.12-1.76-2.74-2.64-6.99-2.64-12.74v-6.89c0-5.92.91-10.24,2.74-12.97,1.82-2.72,4.95-4.09,9.36-4.09,3.05,0,5.38.56,7.02,1.67,1.63,1.12,2.78,2.85,3.44,5.21.67,2.36,1,5.62,1,9.78v6.76h-14.87m-158.33-.74l-10.11-36.49h8.82l3.54,16.54c.9,4.08,1.57,7.55,2,10.43h.26c.3-2.06.97-5.51,2-10.36l3.67-16.61h8.82l-10.23,36.49v17.51h-8.75v-17.51m69.97-21.95v39.45h-6.95l-.77-4.83h-.19c-1.89,3.65-4.72,5.47-8.5,5.47-2.62,0-4.55-.86-5.79-2.57-1.24-1.72-1.87-4.4-1.87-8.05v-29.48h8.88v28.96c0,1.76.19,3.01.58,3.76.39.75,1.03,1.13,1.93,1.13.77,0,1.51-.24,2.22-.71.71-.47,1.23-1.07,1.58-1.8v-31.34h8.88m45.56,0v39.45h-6.95l-.77-4.83h-.19c-1.89,3.65-4.72,5.47-8.5,5.47-2.62,0-4.55-.86-5.79-2.57-1.24-1.72-1.87-4.4-1.87-8.05v-29.48h8.88v28.96c0,1.76.19,3.01.58,3.76.39.75,1.03,1.13,1.93,1.13.77,0,1.51-.24,2.22-.71.71-.47,1.23-1.07,1.58-1.8v-31.34h8.88m-21.42-7.4h-8.82v46.86h-8.69V12.62h-8.82v-7.14h26.32v7.14m42.68,29.8c0,2.87-.12,5.13-.36,6.76-.24,1.63-.63,2.79-1.19,3.48-.56.69-1.31,1.03-2.25,1.03-.71,0-1.41-.17-2.03-.52-.62-.34-1.13-.86-1.51-1.54v-22.4c.3-1.07.82-1.95,1.54-2.64.73-.69,1.52-1.03,2.38-1.03.9,0,1.6.35,2.09,1.06.49.71.84,1.9,1.03,3.57.19,1.67.29,4.05.29,7.14v5.09Zm8.14-16.09c-.54-2.49-1.41-4.29-2.61-5.41-1.2-1.12-2.85-1.67-4.96-1.67-1.63,0-3.15.46-4.57,1.38-1.4.9-2.53,2.16-3.28,3.64h-.07V3.48s-8.56,0-8.56,0v55.99h7.34l.9-3.73h.19c.69,1.33,1.72,2.38,3.09,3.15,1.37.77,2.9,1.16,4.57,1.16,3,0,5.21-1.38,6.63-4.15,1.42-2.77,2.12-7.09,2.12-12.97v-6.24c0-4.42-.27-7.87-.8-10.36M89.02,10.84c-1.04-3.88-4.08-6.91-7.96-7.96-7.02-1.88-35.16-1.88-35.16-1.88,0,0-28.14,0-35.16,1.88-3.88,1.04-6.91,4.08-7.96,7.96-1.88,7.02-1.88,21.66-1.88,21.66,0,0,0,14.64,1.88,21.66,1.04,3.88,4.08,6.91,7.96,7.96,7.02,1.88,35.16,1.88,35.16,1.88,0,0,28.14,0,35.16-1.88,3.88-1.04,6.91-4.08,7.96-7.96,1.88-7.02,1.88-21.66,1.88-21.66,0,0,0-14.64-1.88-21.66m-52.12,35.16v-27l23.38,13.5-23.38,13.5Z" />
                        </svg> -->

                        <!-- Teks Title di bawahnya, dibungkus dalam div atau p untuk penataan yang lebih rapi -->
                        <div class="mt-2"> <!-- mt-2 memberikan sedikit margin atas di Bootstrap -->
                            {{ link.title }}
                        </div>
                    </a>
                    <!-- <div class="text-secondary bg-light px-4 py-3 px-md-6 py-md-4 px-lg-8 py-lg-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="65" fill="currentColor"
                            viewBox="0 0 284 65">
                            <path
                                d="m141.51,52.13c.49-1.29.74-3.39.74-6.31v-12.29c0-2.83-.25-4.9-.74-6.21-.49-1.31-1.36-1.96-2.61-1.96s-2.05.65-2.54,1.96c-.49,1.31-.74,3.38-.74,6.21v12.29c0,2.92.24,5.02.71,6.31.47,1.29,1.33,1.93,2.57,1.93s2.11-.64,2.61-1.93h0Zm-9.98,6.18c-1.78-1.2-3.05-3.07-3.8-5.6-.75-2.53-1.13-5.9-1.13-10.1v-5.73c0-4.25.43-7.66,1.29-10.23.86-2.57,2.2-4.45,4.02-5.63,1.82-1.18,4.22-1.77,7.18-1.77s5.26.6,7.02,1.8c1.76,1.2,3.05,3.08,3.86,5.63.81,2.55,1.22,5.95,1.22,10.2v5.73c0,4.2-.4,7.58-1.19,10.14-.79,2.55-2.08,4.42-3.86,5.6-1.78,1.18-4.19,1.77-7.24,1.77s-5.59-.6-7.37-1.8m137.82-32.22c-.45.56-.75,1.47-.9,2.74-.15,1.27-.22,3.19-.22,5.76v2.83h6.5v-2.83c0-2.53-.09-4.45-.26-5.76-.17-1.31-.48-2.23-.93-2.77-.45-.54-1.15-.81-2.09-.81s-1.64.28-2.09.84h0Zm-1.13,16.61v2c0,2.53.07,4.43.22,5.7.15,1.27.46,2.19.93,2.77.47.58,1.2.87,2.19.87,1.33,0,2.24-.52,2.74-1.55.49-1.03.76-2.75.8-5.15l7.66.45c.04.34.06.82.06,1.42,0,3.65-1,6.37-2.99,8.17-1.99,1.8-4.82,2.7-8.46,2.7-4.38,0-7.44-1.37-9.2-4.12-1.76-2.74-2.64-6.99-2.64-12.74v-6.89c0-5.92.91-10.24,2.74-12.97,1.82-2.72,4.95-4.09,9.36-4.09,3.05,0,5.38.56,7.02,1.67,1.63,1.12,2.78,2.85,3.44,5.21.67,2.36,1,5.62,1,9.78v6.76h-14.87m-158.33-.74l-10.11-36.49h8.82l3.54,16.54c.9,4.08,1.57,7.55,2,10.43h.26c.3-2.06.97-5.51,2-10.36l3.67-16.61h8.82l-10.23,36.49v17.51h-8.75v-17.51m69.97-21.95v39.45h-6.95l-.77-4.83h-.19c-1.89,3.65-4.72,5.47-8.5,5.47-2.62,0-4.55-.86-5.79-2.57-1.24-1.72-1.87-4.4-1.87-8.05v-29.48h8.88v28.96c0,1.76.19,3.01.58,3.76.39.75,1.03,1.13,1.93,1.13.77,0,1.51-.24,2.22-.71.71-.47,1.23-1.07,1.58-1.8v-31.34h8.88m45.56,0v39.45h-6.95l-.77-4.83h-.19c-1.89,3.65-4.72,5.47-8.5,5.47-2.62,0-4.55-.86-5.79-2.57-1.24-1.72-1.87-4.4-1.87-8.05v-29.48h8.88v28.96c0,1.76.19,3.01.58,3.76.39.75,1.03,1.13,1.93,1.13.77,0,1.51-.24,2.22-.71.71-.47,1.23-1.07,1.58-1.8v-31.34h8.88m-21.42-7.4h-8.82v46.86h-8.69V12.62h-8.82v-7.14h26.32v7.14m42.68,29.8c0,2.87-.12,5.13-.36,6.76-.24,1.63-.63,2.79-1.19,3.48-.56.69-1.31,1.03-2.25,1.03-.71,0-1.41-.17-2.03-.52-.62-.34-1.13-.86-1.51-1.54v-22.4c.3-1.07.82-1.95,1.54-2.64.73-.69,1.52-1.03,2.38-1.03.9,0,1.6.35,2.09,1.06.49.71.84,1.9,1.03,3.57.19,1.67.29,4.05.29,7.14v5.09Zm8.14-16.09c-.54-2.49-1.41-4.29-2.61-5.41-1.2-1.12-2.85-1.67-4.96-1.67-1.63,0-3.15.46-4.57,1.38-1.4.9-2.53,2.16-3.28,3.64h-.07V3.48s-8.56,0-8.56,0v55.99h7.34l.9-3.73h.19c.69,1.33,1.72,2.38,3.09,3.15,1.37.77,2.9,1.16,4.57,1.16,3,0,5.21-1.38,6.63-4.15,1.42-2.77,2.12-7.09,2.12-12.97v-6.24c0-4.42-.27-7.87-.8-10.36M89.02,10.84c-1.04-3.88-4.08-6.91-7.96-7.96-7.02-1.88-35.16-1.88-35.16-1.88,0,0-28.14,0-35.16,1.88-3.88,1.04-6.91,4.08-7.96,7.96-1.88,7.02-1.88,21.66-1.88,21.66,0,0,0,14.64,1.88,21.66,1.04,3.88,4.08,6.91,7.96,7.96,7.02,1.88,35.16,1.88,35.16,1.88,0,0,28.14,0,35.16-1.88,3.88-1.04,6.91-4.08,7.96-7.96,1.88-7.02,1.88-21.66,1.88-21.66,0,0,0-14.64-1.88-21.66m-52.12,35.16v-27l23.38,13.5-23.38,13.5Z" />
                        </svg>
                    </div> -->
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    name: "BeritaTerkini",
    data() {
        return {
            linkList: [],
            loading: true,
            error: null,
        };
    },
    methods: {
        async fetchNews() {
            try {
                const response = await axios.get("tautan");
                this.linkList = response.data.data;
                // console.log(response.data)
            } catch (err) {
                this.error = "Gagal memuat berita. Coba lagi nanti.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("id-ID", options);
        },
    },
    created() {
        this.fetchNews();
    },
};
</script>

<style>
.img-monochrome {
    filter: grayscale(100%);
    transition: filter 0.3s ease;
}

.img-monochrome:hover {
    filter: grayscale(0%);
}


.px-6 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important
}

.px-7 {
    padding-left: 4rem !important;
    padding-right: 4rem !important
}

.px-8 {
    padding-left: 4.5rem !important;
    padding-right: 4.5rem !important
}

.px-9 {
    padding-left: 5rem !important;
    padding-right: 5rem !important
}

.py-6 {
    padding-bottom: 3.5rem !important;
    padding-top: 3.5rem !important
}

.py-7 {
    padding-bottom: 4rem !important;
    padding-top: 4rem !important
}

.py-8 {
    padding-bottom: 4.5rem !important;
    padding-top: 4.5rem !important
}

.py-9 {
    padding-bottom: 5rem !important;
    padding-top: 5rem !important
}

.mb-6 {
    margin-bottom: 3.5rem !important
}

.mb-7 {
    margin-bottom: 4rem !important
}

.mb-8 {
    margin-bottom: 4.5rem !important
}

.mb-9 {
    margin-bottom: 5rem !important
}

.mb-auto {
    margin-bottom: auto !important
}

@media(min-width:576px) {
    .px-sm-6 {
        padding-left: 3.5rem !important;
        padding-right: 3.5rem !important
    }

    .px-sm-7 {
        padding-left: 4rem !important;
        padding-right: 4rem !important
    }

    .px-sm-8 {
        padding-left: 4.5rem !important;
        padding-right: 4.5rem !important
    }

    .px-sm-9 {
        padding-left: 5rem !important;
        padding-right: 5rem !important
    }

    .py-sm-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-sm-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-sm-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-sm-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .mb-sm-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-sm-7 {
        margin-bottom: 4rem !important
    }

    .mb-sm-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-sm-9 {
        margin-bottom: 5rem !important
    }

    .mb-sm-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:768px) {
    .px-md-6 {
        padding-left: 3.5rem !important;
        padding-right: 3.5rem !important
    }

    .px-md-7 {
        padding-left: 4rem !important;
        padding-right: 4rem !important
    }

    .px-md-8 {
        padding-left: 4.5rem !important;
        padding-right: 4.5rem !important
    }

    .px-md-9 {
        padding-left: 5rem !important;
        padding-right: 5rem !important
    }

    .py-md-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-md-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-md-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-md-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .mb-md-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-md-7 {
        margin-bottom: 4rem !important
    }

    .mb-md-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-md-9 {
        margin-bottom: 5rem !important
    }

    .mb-md-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:992px) {
    .px-lg-6 {
        padding-left: 3.5rem !important;
        padding-right: 3.5rem !important
    }

    .px-lg-7 {
        padding-left: 4rem !important;
        padding-right: 4rem !important
    }

    .px-lg-8 {
        padding-left: 4.5rem !important;
        padding-right: 4.5rem !important
    }

    .px-lg-9 {
        padding-left: 5rem !important;
        padding-right: 5rem !important
    }

    .py-lg-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-lg-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-lg-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-lg-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .mb-lg-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-lg-7 {
        margin-bottom: 4rem !important
    }

    .mb-lg-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-lg-9 {
        margin-bottom: 5rem !important
    }

    .mb-lg-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:1200px) {
    .px-xl-6 {
        padding-left: 3.5rem !important;
        padding-right: 3.5rem !important
    }

    .px-xl-7 {
        padding-left: 4rem !important;
        padding-right: 4rem !important
    }

    .px-xl-8 {
        padding-left: 4.5rem !important;
        padding-right: 4.5rem !important
    }

    .px-xl-9 {
        padding-left: 5rem !important;
        padding-right: 5rem !important
    }

    .py-xl-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-xl-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-xl-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-xl-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .mb-xl-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-xl-7 {
        margin-bottom: 4rem !important
    }

    .mb-xl-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-xl-9 {
        margin-bottom: 5rem !important
    }

    .mb-xl-auto {
        margin-bottom: auto !important
    }
}

@media(min-width:1400px) {
    .px-xxl-6 {
        padding-left: 3.5rem !important;
        padding-right: 3.5rem !important
    }

    .px-xxl-7 {
        padding-left: 4rem !important;
        padding-right: 4rem !important
    }

    .px-xxl-8 {
        padding-left: 4.5rem !important;
        padding-right: 4.5rem !important
    }

    .px-xxl-9 {
        padding-left: 5rem !important;
        padding-right: 5rem !important
    }

    .py-xxl-6 {
        padding-bottom: 3.5rem !important;
        padding-top: 3.5rem !important
    }

    .py-xxl-7 {
        padding-bottom: 4rem !important;
        padding-top: 4rem !important
    }

    .py-xxl-8 {
        padding-bottom: 4.5rem !important;
        padding-top: 4.5rem !important
    }

    .py-xxl-9 {
        padding-bottom: 5rem !important;
        padding-top: 5rem !important
    }

    .mb-xxl-6 {
        margin-bottom: 3.5rem !important
    }

    .mb-xxl-7 {
        margin-bottom: 4rem !important
    }

    .mb-xxl-8 {
        margin-bottom: 4.5rem !important
    }

    .mb-xxl-9 {
        margin-bottom: 5rem !important
    }

    .mb-xxl-auto {
        margin-bottom: auto !important
    }
}
</style>